import * as angular from "angular";

angular
  .module('bringoz.admin.coordinations')
  .config(coordinationsConfig);

/* @ngInject */
function coordinationsConfig($stateProvider) {

  $stateProvider

    .state('coordinations', {
      parent: 'bringoz.site',
      url: '/coordinations',
      template: '<coordinations-list coordinations="coordinations"></coordinations-list>',
      controller: function ($stateParams, triBreadcrumbsService, coordinations, $scope, site) {

        $scope.coordinations = coordinations;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Dropoff Scheduling", state: "coordinations"});
        triBreadcrumbsService.addCrumb({name: "Dispatch"});
      },
      resolve: {
        coordinations: ($coordinations, site) => {
          const coordinationsRef = $coordinations();
          return coordinationsRef.$getAll()
            .then((coordinationIds) => {
              return coordinationsRef.$asyncValues(coordinationIds);
            })
        }
      }
    })

    .state('create-new-coordination', {
      parent: 'bringoz.site',
      url: '/create',
      template: '<create-new-coordination></create-new-coordination>',
      controller: function (triBreadcrumbsService, site) {
        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Create'});
        triBreadcrumbsService.addCrumb({name: "Coordinations", state: "coordinations"});
      }
    })
    .state('coordination-detail', {
      parent: 'bringoz.site',
      url: '/coordination/:id',
      template: '<coordination-detailed-view flex coordination="coordination" services="services"></coordination-detailed-view>',
      controller: function ($stateParams, coordination, services, triBreadcrumbsService, $coordinations, $scope, site) {

        $scope.services = services;
        $scope.coordination = coordination;
        $coordinations($stateParams.id).$bind($scope, 'coordination');

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: $scope.coordination.id, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: "Coordinations", state: "coordinations"});

      },
      resolve: {
        coordination: ($coordinations, $stateParams, site) => {
          return $coordinations($stateParams.id).$asyncValue();
        },
        services: (coordinationRequests, $stateParams, site) => {
          return coordinationRequests.getServices($stateParams.id);
        }
      }
    })

    .state('edit-coordination', {
      parent: 'bringoz.site',
      url: '/coordination/:id/edit',
      template: '<edit-coordination coordination="coordination"></edit-coordination>',
      controller: function (triBreadcrumbsService, coordination, $scope, site) {
        // Bread Crumbs
        // triBreadcrumbsService.reset();
        // triBreadcrumbsService.addCrumb({name: 'Edit'});
        // triBreadcrumbsService.addCrumb({name: "Coordinations", state: "coordinations"});
        // triBreadcrumbsService.addCrumb({name: "Coordinations", state: "coordinations"});
        $scope.coordination = coordination;
      },
      resolve: {
        coordination: ($coordinations, $stateParams, site) => {
          return $coordinations($stateParams.id).$get();
        }
      }
    });

}
